import i18n from "@/i18n";

const t = i18n.global.t;

export const formatMatchLevel = (match?: string | null): string => {
  if (!match) {
    return "-";
  }
  const map: Record<string, string> = {
    EXACT: t("DEALS.BASELAYER.MATCH_EXACT"),
    PARTIAL: t("DEALS.BASELAYER.MATCH_PARTIAL"),
    SIMILAR: t("DEALS.BASELAYER.MATCH_SIMILAR"),
    STATE: t("DEALS.BASELAYER.MATCH_STATE"),
    NO_MATCH: t("DEALS.BASELAYER.MATCH_NO_MATCH"),
    FULL: t("DEALS.BASELAYER.MATCH_FULL"),
  };
  return map[match] ?? match;
};

const matchLevelClassMap: Record<string, string> = {
  EXACT: "bg-green-100 text-green-800",
  FULL: "bg-green-100 text-green-800",
  PARTIAL: "bg-yellow-100 text-yellow-800",
  SIMILAR: "bg-yellow-100 text-yellow-800",
  STATE: "bg-yellow-100 text-yellow-800",
  NO_MATCH: "bg-red-100 text-red-800",
};

export const getMatchLevelClasses = (match?: string | null): string => {
  if (!match) {
    return "bg-gray-100 text-gray-800";
  }
  return matchLevelClassMap[match] ?? "bg-gray-100 text-gray-800";
};

const riskLevelClassMap: Record<string, string> = {
  low: "bg-green-100 text-green-800",
  medium: "bg-yellow-100 text-yellow-800",
  high: "bg-red-100 text-red-800",
};

export const getRiskLevelClasses = (level?: string): string => {
  if (!level) {
    return "bg-gray-100 text-gray-800";
  }
  return riskLevelClassMap[level.toLowerCase()] ?? "bg-gray-100 text-gray-800";
};

export const isBaselayerBusinessRegistrationsAttribute = <T>(
  attributeResult: T
) => {
  const baselayerBusinessRegistrationsKeys = [
    "dissolution_date",
    "standing",
    "domestic_status",
  ] as const;

  return (
    Array.isArray(attributeResult) &&
    attributeResult.every(
      (item) =>
        typeof item === "object" &&
        item !== null &&
        baselayerBusinessRegistrationsKeys.every((key) => key in item)
    )
  );
};
